import styled from 'styled-components'
import { darken } from 'polished'
import { Spinner } from 'lib/ui/components/Spinner'

export const ButtonContent = styled.div`
  flex-grow: 1;
  padding: 0 2em;
  text-align: center;
`

export const LeftAdHoc = styled.div`
  padding: 0 2em;
  border-radius: 25px 0 0 25px;
  background: ${props => props.theme.palette.primary.alphaDark};
  transition: background 300ms ease;
`

export const StyledButton = styled.button<any>`
  ${props => props.theme.css.buttonPrimary}
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0;
  ${props => props.isLoading && `
    cursor: wait !important;
  `}

  ${Spinner} {
    position: absolute;
    top: 17px;
    right: 13px;
  }

  ${ButtonContent} {
    ${props => props.hasLeftAdHoc && `
      padding: 0 4em 0 2em;
    `}
  }

  &:hover,
  &:focus {
    ${LeftAdHoc} {
      background: ${props => darken(0.1, props.theme.palette.primary.alphaDark)};
    }
  }
`
